import type { FC } from 'react';

import type { CareerType, CountryCodeType } from 'types/types';
import { job_position_instruction } from 'data/translationKeys';
import useLocalised from 'customHooks/useLocalised/useLocalised';
import { emailAdresses } from 'data/constants';
import CareerForm from './CareerForm';
import TextBullet from './text-bullets';
import { Body } from 'components/text';

interface ICareerAccordion {
  career: CareerType;
  countryCodes: CountryCodeType[];
}

const CareerAccordion: FC<ICareerAccordion> = ({ countryCodes, career }) => {
  const {
    introduction,
    description,
    requirements,
    hasForm,
    subheading,
    secondSubheading,
    contact,
  } = career;

  const job_position_instruction_text = useLocalised(job_position_instruction);

  return (
    <div className="accordion-container">
      <div className="accordion-container__left">
        {introduction && <Body color="grey-dark">{introduction}</Body>}
        {description && (
          <>
            <Body
              color="grey-dark"
              weight="demiBold"
              className="career-description-title"
            >
              {subheading}
            </Body>
            <TextBullet
              className="career-description-list"
              content={description}
            />
          </>
        )}
        {requirements && requirements.length > 0 && (
          <>
            <Body
              color="grey-dark"
              weight="demiBold"
              className="career-description-title"
            >
              {secondSubheading}
            </Body>
            <TextBullet
              className="career-requirement-list"
              content={requirements}
            />
          </>
        )}

        {!hasForm && (
          <div className="career-instruction-text">
            {`${job_position_instruction_text} `}
            <a
              className="career-instruction-text__link"
              href={`mailto:${contact}`}
            >
              {contact}
            </a>
          </div>
        )}
      </div>
      {hasForm && (
        <div className="accordion-container__right">
          <CareerForm countryCodes={countryCodes} />
        </div>
      )}
    </div>
  );
};

export default CareerAccordion;
